__turbopack_context__.v({
  "card": "Card-module-scss-module__TfMA5q__card",
});
